import React, { useState, useEffect } from 'react';

import InputDialog from 'components/dialog/InputDialog';
import MainTextfield from 'components/textfield/MainTextfield';

import { MAX_TEXT_LENGTH } from 'domain/recipe/usecases/validator';

const IngredientsDialog = ({
  isOpened,
  closeDialog,
  ingredientAction,
  title = '',
  initialIngredient,
  actionButtonLabel = '',
}) => {
  const [ingredient, setIngredient] = useState('');

  useEffect(() => {
    if (initialIngredient) setIngredient(initialIngredient.ingredientText);
    else setIngredient('');
  }, [initialIngredient]);

  const _reset = () => {
    setIngredient('');
  };

  const _ingredientAction = () => {
    ingredientAction(ingredient);
    _closeDialog();
  };

  const validator = (value) => {
    if (value.trim().length === 0) return 'Ingredient cannot be empty';
    if (value.trim().length > MAX_TEXT_LENGTH)
      return `Ingredient cannot have more than ${MAX_TEXT_LENGTH} characters`;

    return null;
  };

  const _closeDialog = () => {
    _reset();
    closeDialog();
  };

  return (
    <InputDialog
      title={title}
      closeDialog={_closeDialog}
      inputValue={ingredient}
      onInputChange={setIngredient}
      validator={validator}
      isOpened={isOpened}
      submitButtonLabel={actionButtonLabel}
      onSubmit={_ingredientAction}
      renderInput={(errorMessage, onChange, value) => {
        return (
          <MainTextfield
            fullWidth={true}
            autoFocus={true}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            helperText={errorMessage}
            error={!!errorMessage}
            variant="standard"
          ></MainTextfield>
        );
      }}
    ></InputDialog>
  );
};

export default IngredientsDialog;
